import React from "react";

const ErrorComponent = (props: { errors: any, field: string }) => {

    const {errors, field} = props;

    return errors && errors[field] ? <p className="mt-2 text-sm text-red-600" id="email-error">{errors[field]}</p> : null;
};

export default ErrorComponent;